module.exports = __webpack_public_path__ + "img/list_9.08741a70.jpg";